import React from "react";
import PostCard from "./PostCard";
import moment from "moment";

const PostList = ({
  posts,
  hideVideo,
  setReplyTo,
  setCustomer,
  handleVideo,
  hideReplies,
  handleReport,
  handleThread,
}) => {
  const renderPosts = () => {
    if (Array.isArray(posts)) {
      if (posts.length === 0) return <p>No hay comentarios.</p>;
      return posts.map((post) => (
        <PostCard
          key={post.post_id}
          post={post}
          hideVideo={hideVideo}
          setReplyTo={setReplyTo}
          setCustomer={setCustomer}
          handleVideo={handleVideo}
          hideReplies={hideReplies}
          handleReport={handleReport}
          handleThread={handleThread}
        />
      ));
    }
  };
  return <div>{renderPosts()}</div>;
};

export default PostList;
